import { Container } from 'inversify';
import type { Newable } from 'ts-essentials';
import type { BindingToSyntax } from 'inversify/lib/syntax/binding_to_syntax.js';

declare module 'inversify' {
  export interface Container {
    get<T>(input: string | symbol | Newable<T>): T;
    bind<T>(serviceIdentifier: string | symbol | Newable<T>): BindingToSyntax<T>;
    tryGet<T>(this: Container, serviceIdentifier: string | symbol | Newable<T>): T | undefined;
  }
}

export function tryGet<T>(
  container: Container,
  serviceIdentifier: string | symbol | Newable<T>
): T | undefined {
  if (container.isBound(serviceIdentifier)) {
    return container.get<T>(serviceIdentifier);
  }

  return undefined;
}

Container.prototype.tryGet = function <T>(
  this: Container,
  serviceIdentifier: string | symbol | Newable<T>
): T | undefined {
  return tryGet(this, serviceIdentifier);
};
